import { Module, Mutation, VuexModule } from 'vuex-module-decorators'
import store from '..'

@Module({ namespaced: true })
export default class Confirmation extends VuexModule {
  isOpen = false

  @Mutation
  open(): void {
    this.isOpen = true
    // use the content overlay onclick function
    store.commit('openContentOverlay', () => {
      store.commit('confirmation/close')
    })
  }

  @Mutation
  close(): void {
    this.isOpen = false
    store.commit('closeContentOverlay', false)
  }
}
